// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Ib0X","list":"PatternAutocomplete_list__2HtEa"};